(function () {
	'use strict';
	angular.module('app.leanProjects')
		.controller('taskForm', taskForm);

	taskForm.$inject = ['$scope', '$timeout', '$filter', 'taskFormService', 'newProjectService', 'leanProjectAuthService', 'projectTaskGroupService'];

	function taskForm($scope, $timeout, $filter, taskFormService, newProjectService, leanProjectAuthService, projectTaskGroupService) {
		var vm = this;
		// view model functions
		vm.projectNdx = $scope.projectNdx;
		vm.leanDirFactoryNdx = $scope.leanDirFactoryNdx;
		vm.action = $scope.action;
		vm.projectTaskGroupId = $scope.projectTaskGroupId || -1;
		vm.viewMode = $scope.viewMode;
		vm.close = close;
		vm.save = save;
		vm.datePickerOpen = datePickerOpen;
		vm.updatePercentComplete = updatePercentComplete;
		vm.updateTaskStatus = updateTaskStatus;
		vm.originalTask = {};
		vm.dueDateAfterProjectDueDate = false;
		vm.startDateChange = startDateChange;
		vm.dueDateChange = dueDateChange;
		vm.advancedDatesChange = advancedDatesChange;
		vm.toggleAdvancedDatesAccordion = toggleAdvancedDatesAccordion;
		vm.details = $scope.details;
		vm.actionIsAllowed = actionIsAllowed;
		vm.filterManagers = filterManagers;
		// 24hr after unix epoch, to avoid any timezone issues
		vm.minDate = new Date(86400000);
		vm.today = new Date();
		vm.todayStartDay = moment().startOf('day');
		vm.alternateUserList = [];
		vm.invalidDateSelection = false;
		vm.isSaveButtonDisabled = false;
		vm.isAdvancedDateControlShown = false;
		vm.isAdvancedDateControlOpen = true;
		vm.actualStartDateDisabled = false;
		vm.actualCompletionDateDisabled = false;
		vm.invalidAdvancedDateSelection = false;

		var advancedDatesUpdateMap = {};
		var advancedDateFields = [
			'originalStartDate',
			'originalDueDate',
			'actualStartDate',
			'actualCompletionDate'
		];

		init();

		function init() {
			// init view model project
			vm.taskPriorities = [{
				id: 'Low',
				text: 'Low'
			}, {
				id: 'Medium',
				text: 'Medium'
			}, {
				id: 'High',
				text: 'High'
			}];
			vm.states = [{
				id: 'Pending',
				text: 'Pending'
			}, {
				id: 'Started',
				text: 'Started'
			}, {
				id: 'Completed',
				text: 'Completed'
			}];

			vm.taskGroups = [{
				id: -1,
				name: 'Ungrouped Tasks'
			}];

			vm.percents = getPercentages(vm.task);
			if (vm.action == 'Edit') {
				vm.task = {};
				getTask();
			} else {
				getDropDownListsFromServer(vm.task);
				vm.task = {};
				vm.task.stateType = 'Pending';
				vm.task.percentComplete = 0;
				vm.task.priorityType = 'Medium';
				vm.task.projectedStartDate = new Date();
				vm.task.projectTaskGroupId = vm.projectTaskGroupId;
				vm.task.projectedCompleteDate = moment().add(14, 'days').toDate();
				dueDateChange();
			}
			vm.isAdvancedDateControlShown = actionIsAllowed('showAdvancedDates');
		}

		function actionIsAllowed(action, responsibleNdx) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details, responsibleNdx);
		}

		function getTask() {
			vm.isSupplier = globalConfig.user.role == 'Supplier';
			taskFormService.getTask($scope.task.ndx, vm.projectNdx, vm.leanDirFactoryNdx).then(function (task) {
				task.data.projectedCompleteDate = new Date(task.data.projectedCompleteDate);
				var projectedCompleteDateLocal = moment(task.data.projectedCompleteDate).add(task.data.projectedCompleteDate.getTimezoneOffset(), 'minutes');
				task.data.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;

				task.data.projectedStartDate = new Date(task.data.projectedStartDate);
				var projectedStartDateLocal = moment(task.data.projectedStartDate).add(task.data.projectedStartDate.getTimezoneOffset(), 'minutes');
				task.data.projectedStartDate = moment(projectedStartDateLocal)._d;
				updateTaskDatesOffset(task.data, 'add');
				checkAdvancedDates(task.data);
				task.data.projectTaskGroupId = task.data.projectTaskGroupId || -1;

				vm.originalTask = jQuery.extend({}, task.data, true);
				getDropDownListsFromServer(vm.originalTask);
				vm.task = task.data;
				vm.task.name = _.unescape(vm.task.name);
				dueDateChange();
			});
		}

		function updatePercentComplete() {
			if (vm.task.stateType === 'Completed') {
				vm.task.percentComplete = 100;
			}
			if (vm.task.stateType === 'Pending') {
				vm.task.percentComplete = 0;
			}
			if (vm.task.stateType !== 'Completed' && vm.task.percentComplete === 100) { 
				vm.task.percentComplete = 0;
			}
			checkAdvancedDates(vm.task);
		}

		function updateTaskStatus() { 
			if (vm.task.stateType !== 'Completed' && vm.task.percentComplete === 100) {
				vm.task.stateType = 'Completed';
			}
			checkAdvancedDates(vm.task);
		}

		function getPercentages() {
			var percentages = [];
			for (var i = 0; i <= 20; i++) {
				percentages.push({
					id: i * 5,
					text: (i * 5) + '%'
				});
			}
			return percentages;
		}

		function getDropDownListsFromServer(taskObj) {
			var inactiveResponsibleUser = typeof taskObj !== 'undefined' && taskObj.responsibleStatus == 'inactive' ? taskObj.taskResponsibleId : null;
			newProjectService.getUsers(vm.leanDirFactoryNdx, inactiveResponsibleUser).then(function (users) {
				if (vm.action == 'Edit') {
					var filteredResults = [];
					angular.forEach(users, function (item) {
						if (item.id == vm.task.taskResponsibleId) {
							filteredResults.push(item);
						}
					});
					vm.alternateUserList = filteredResults;
				}

				vm.taskManagers = users.sort(function (a, b) { return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()); });
			});

			projectTaskGroupService.getTaskGroups(vm.projectNdx, vm.leanDirFactoryNdx).then(function (taskGroups) {
				vm.taskGroups = vm.taskGroups.concat(taskGroups);
			});
		}

		function filterManagers(searchTerm) {
			return newProjectService.filterUsers(vm.taskManagers, searchTerm);
		}

		function cleanUpTaskObject() {
			var taskObj = jQuery.extend({}, vm.task);
			var projectedCompleteDateUtc = moment(taskObj.projectedCompleteDate)
				.subtract(taskObj.projectedCompleteDate.getTimezoneOffset(), 'minutes');
			taskObj.projectedCompleteDate = moment(projectedCompleteDateUtc)._d;

			var projectedStartDateUtc = moment(taskObj.projectedStartDate)
				.subtract(taskObj.projectedStartDate.getTimezoneOffset(), 'minutes');
			taskObj.projectedStartDate = moment(projectedStartDateUtc)._d;
			updateTaskDatesOffset(taskObj, 'subtract');
			cleanupAdvancedDates(taskObj);
			delete taskObj.firstName;
			delete taskObj.lastName;
			delete taskObj.responsible;
			delete taskObj.responsibleStatus;
			return taskObj;
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			if (typeof vm.task.ndx === 'undefined') {
				updateTaskDatesOffset(vm.task, 'subtract');
				taskFormService.createTask(vm.task, vm.projectNdx, vm.leanDirFactoryNdx).then(function (message) {
					var projectedStartDateUtc = moment(vm.task.projectedStartDate)
						.subtract(vm.task.projectedStartDate.getTimezoneOffset(), 'minutes');
					vm.task.projectedStartDate = moment(projectedStartDateUtc)._d;

					var projectedCompleteDateUtc = moment(vm.task.projectedCompleteDate)
						.subtract(vm.task.projectedCompleteDate.getTimezoneOffset(), 'minutes');
					vm.task.projectedCompleteDate = moment(projectedCompleteDateUtc)._d;

					if (message === 'Task created successfully') {
						updateProjectDueDate(true);
						broadCastProjectStatusUpdate();
					}
					vm.isSaveButtonDisabled = false;
					$scope.result(message, message === 'Task created successfully');
				});
			} else {
				var lastModified = (new Date()).toUTCString();
				if (typeof vm.task.lastModified !== 'undefined') {
					lastModified = (new Date(vm.task.lastModified)).toUTCString();
				}
				if (!angular.equals(vm.task, vm.originalTask)) {
					var updateProjectStatus =
						vm.task.projectedCompleteDate !== vm.originalTask.projectedCompleteDate ||
						vm.task.originalStartDate !== vm.originalTask.originalStartDate ||
						vm.task.originalDueDate !== vm.originalTask.originalDueDate ||
						vm.task.actualStartDate !== vm.originalTask.actualStartDate ||
						vm.task.actualCompletionDate !== vm.originalTask.actualCompletionDate ||
						vm.task.stateType !== vm.originalTask.stateType ||
						vm.task.percentComplete !== vm.originalTask.percentComplete;

					taskFormService.updateTask(cleanUpTaskObject(vm.task), $scope.projectNdx,
						$scope.leanDirFactoryNdx, lastModified).then(function (message) {
						if (message === 'Task updated successfully') {
							updateProjectDueDate(true);
							if (updateProjectStatus) {
								broadCastProjectStatusUpdate();
							}
						}

						$scope.result(message, message === 'Task updated successfully');
						vm.isSaveButtonDisabled = false;
					});
				} else {
					$scope.result('', true);
					vm.isSaveButtonDisabled = false;
				}

			}
		}

		function close() {
			$scope.result('', false);
		}

		function datePickerOpen(type) {
			$timeout(function () {
				if (type === 'start') {
					vm.startDateOpened = true;
				} else if (type === 'end') {
					vm.endDateOpened = true;
				} else if (type === 'originalStart') {
					vm.originalStartDateOpened = true;
				} else if (type === 'originalEnd') {
					vm.originalEndDateOpened = true;
				} else if (type === 'actualStart') {
					vm.actualStartDateOpened = true;
				} else if (type === 'actualEnd') {
					vm.actualEndDateOpened = true;
				}
			});
		}

		function updateProjectDueDate(updateDate) {
			if (vm.dueDateAfterProjectDueDate && updateDate) {
				var projectedCompleteDateLocal = moment(vm.task.projectedCompleteDate).add(vm.task.projectedCompleteDate.getTimezoneOffset(), 'minutes');
				vm.task.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;
				vm.details.endDate = moment(vm.task.projectedCompleteDate).valueOf();
			}
		}

		function startDateChange() {
			checkDates();
		}

		function dueDateChange() {
			checkDates();
			var taskDate = moment(vm.task.projectedCompleteDate);
			if (taskDate != null && taskDate.isValid()) {
				var projectDate = moment(vm.details.endDate);
				var result = (moment(taskDate).isAfter(projectDate, 'days'));
				vm.dueDateAfterProjectDueDate = result;
			}
		}

		function checkDates() {
			var startDate = moment(vm.task.projectedStartDate);
			var dueDate = moment(vm.task.projectedCompleteDate);
			if (startDate && dueDate) {
				vm.invalidDateSelection = startDate.isAfter(dueDate, 'days');
			}
		}

		function broadCastProjectStatusUpdate() {
			$scope.$emit('updateLastModified', {});
		}

		function updateTaskDatesOffset(task, method) {
			advancedDateFields.forEach(function (dateField) {
				updateTaskDateOffset(task, dateField, method);
			});
		}

		function updateTaskDateOffset(task, dateField, method) {
			if (task[dateField]) {
				task[dateField] = new Date(task[dateField]);
				var dateUtc = moment(task[dateField])[method](task[dateField].getTimezoneOffset(), 'minutes');
				task[dateField] = moment(dateUtc).toDate();
			}
		}

		function checkAdvancedDates(task) {
			if (task.stateType === 'Pending') {
				vm.actualStartDateDisabled = true;
				vm.actualCompletionDateDisabled = true;
				task.actualStartDate = null;
				task.actualCompletionDate = null;
			} else if (task.stateType === 'Started') {
				vm.actualStartDateDisabled = false;
				vm.actualCompletionDateDisabled = true;
				task.actualCompletionDate = null;
				if (!task.actualStartDate) {
					task.actualStartDate = vm.todayStartDay.toDate();
				}
				if (vm.actualStartDateTemp) {
					task.actualStartDate = vm.actualStartDateTemp;
				}
			} else if (task.stateType === 'Completed') {
				vm.actualStartDateDisabled = false;
				vm.actualCompletionDateDisabled = false;
				if (!task.actualCompletionDate) {
					task.actualCompletionDate = vm.todayStartDay.toDate();
				}
				if (vm.actualCompletionDateTemp) {
					task.actualCompletionDate = vm.actualCompletionDateTemp;
				}
				if (!task.actualStartDate) {
					task.actualStartDate = vm.todayStartDay.toDate();
				}
				if (vm.actualStartDateTemp) {
					task.actualStartDate = vm.actualStartDateTemp;
				}
			}
		}

		function advancedDatesChange(dateField) {
			if (vm.task.actualStartDate) {
				vm.actualStartDateTemp = vm.task.actualStartDate;
			}
			if (vm.task.actualCompletionDate) {
				vm.actualCompletionDateTemp = vm.task.actualCompletionDate;
			}
			validateAdvancedDates();
			advancedDatesUpdateMap[dateField] = true;
		}

		function toggleAdvancedDatesAccordion() {
			vm.isAdvancedDateControlOpen = !vm.isAdvancedDateControlOpen;
		}

		function validateAdvancedDates() {
			var originalStartDate = moment(vm.task.originalStartDate);
			var originalDueDate = moment(vm.task.originalDueDate);
			var actualStartDate = moment(vm.task.actualStartDate);
			var actualDueDate = moment(vm.task.actualCompletionDate);
			if ((originalStartDate && originalDueDate) || (actualStartDate && actualDueDate)) {
				vm.invalidAdvancedDateSelection = originalStartDate.isAfter(originalDueDate, 'days')
					|| actualStartDate.isAfter(actualDueDate, 'days');
			}
		}

		function cleanupAdvancedDates(task) {
			advancedDateFields.forEach(function (dateField) {
				if (!advancedDatesUpdateMap[dateField]) {
					task[dateField] = null;
				}
			});
		}
	}
})();
